import { connect } from 'react-redux';
import { getName, getIllustration, getAltText, getNotes } from '../selectors';
import { getSummaryFieldValues, getOptionThumbnails } from '../selectors/hybrid';
import MouldingSummary from '../components/MouldingSummary';

const mapStateToProps = (state, ownProps) => {
  const configuratorState = state.ConfiguratorStore;
  return {
    name: getName(configuratorState),
    illustration: getIllustration(configuratorState),
    imageAltText: getAltText(configuratorState),
    summaryValues: getSummaryFieldValues(configuratorState),
    thumbnails: getOptionThumbnails(configuratorState),
    notes: getNotes(configuratorState)
  };
};

const MouldingSummaryContainer = connect(
  mapStateToProps
)(MouldingSummary);

export default MouldingSummaryContainer;
